import React, { useEffect, useState } from "react";
import ForgetPasswordPage from "../../Pages/ForgetPasswordPage";
import { useDispatch, useSelector } from "react-redux";
import { apiPasswordResetRequest } from "../../Redux/actions/auth";

const ForgetPasswordContainer = () => {
  const auth = useSelector(state => state.auth)
  const dispatch = useDispatch()
  const [isMailSent, setISMailSent] = useState(false);

  const handleMailSent = (email) => {
    console.log('handleMailSent',email);
    dispatch(apiPasswordResetRequest(email))
  };
  useEffect(() => {
    if (auth?.resetEmailSent) {
      setISMailSent(true);
    }
  }, [auth])
  return (
    <ForgetPasswordPage
      auth={auth}
      isMailSent={isMailSent}
      handleMailSent={handleMailSent}
    />
  );
};

export default ForgetPasswordContainer;
